<template>
  <div>
    <div class="popup-content-inner">
      <div class="tableContainer">
        <DxDataGrid
          :data-source="store"
          :show-borders="false"
          :show-column-lines="false"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :column-auto-width="true"
          :show-column-headers="true"
          :show-colon="false"
          :remote-operations="true"
          :hover-state-enabled="false"
          :show-row-lines="false"
          :row-alternation-enabled="false"
          :word-wrap-enabled="true"
          :no-data-text="$t('noDataTextSummary')"
          class="custom-grid custom-grid-summary"
        >
          <DxColumn
            :caption="$t('TechnicalParameter')"
            data-field="parametro"
          />
          <DxColumn
            :caption="$t('Technique')"
            alignment="center"
            data-field="tecnica"
          />
          <!-- <DxColumn
            :caption="$t('description')"
            alignment="center"
            data-field=""
          /> -->
          <DxColumn
            :caption="$t('PNT')"
            alignment="center"
            data-field="nombrePNT"
          />
          <DxColumn
            :caption="$t('MinimumValue')"
            alignment="center"
            data-field="valorMinimo"
          />
          <DxColumn
            :caption="$t('MaximumValue')"
            alignment="center"
            data-field="valorMaximo"
          />
          <DxColumn
            :caption="$t('UnitMeasure')"
            alignment="center"
            data-field="UnidadMedida"
          />
          <DxColumn
            :caption="$t('AccreditationInfo')"
            alignment="center"
            data-field="Acreditacion"
          />
          <DxPager
            :allowed-page-sizes="[5, 10, 15, 20]"
            :show-page-size-selector="true"
            info-text="{2} items"
            :visible="true"
          />
          <DxPaging :page-size="5" />
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import {
  DxDataGrid,
  DxColumn,
  DxPager,
  DxPaging,
} from 'devextreme-vue/data-grid';

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxPager,
    DxPaging,
  },
  props: {
    store: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      subcontratado: '',
      loaded: false,
    };
  },
  computed: {
    ...mapState('serviceCatalog', {
      showCatalogDetailsPopup: 'showCatalogDetailsPopup',
      servicesAnalyticsDetails: 'servicesAnalyticsDetails',
      title: 'popupTitle',
    }),
  },
  methods: {
    hide() {
      this.setShowCatalogDetailsPopup(false);
    },
    ...mapActions('serviceCatalog', ['setShowCatalogDetailsPopup']),
  },
};
</script>
